import { connect } from 'react-redux';

// Import utils.
import UserProfileForm from '../Forms/UserProfileForm';

const Profile = () => {
  return (
    <div className="rounded-lg border border-gray-300 bg-white p-4">
      <div className="grid grid-cols-1 items-center">
        <div className="col-span-1">
          <UserProfileForm />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {})(Profile);
